type ThenArg<T> = T extends PromiseLike<infer U> ? U : T

export class Pipeline<T extends (...args: any) => any> {
  #stack: T[];
  constructor() {
    this.#stack = [];
  }

  push = (pipe: T) => this.#stack.push(pipe);

  async execute(...params: Parameters<T>): Promise<ThenArg<ReturnType<T>> | void> {
    let newParams: Parameters<T> = params;
    let finalReturnValue: ThenArg<ReturnType<T>> | void = undefined;
    for (let pipe of this.#stack) {
      await pipe(...newParams as Iterable<Parameters<T>>);
    }
    return finalReturnValue;
  }
}